import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47686 17.5231 2 12 2C6.47686 2 2 6.47686 2 12C2 13.6982 2.42455 15.3374 3.2224 16.7951C3.83556 17.9145 4.65887 18.908 5.64474 19.7216C7.42283 21.1855 9.64993 22 12 22C17.5231 22 22 17.5231 22 12ZM3 12C3 7.02914 7.02914 3 12 3C16.9709 3 21 7.02914 21 12C21 16.9709 16.9709 21 12 21C9.88406 21 7.88107 20.2675 6.2808 18.95C5.39304 18.2173 4.65145 17.3224 4.09952 16.3148C3.38183 15.0035 3 13.5293 3 12ZM11.3257 12L8.13966 15.186C7.95345 15.3722 7.95345 15.6741 8.13966 15.8603C8.32586 16.0466 8.62777 16.0466 8.81397 15.8603L12 12.6743L15.186 15.8603C15.3722 16.0466 15.6741 16.0466 15.8603 15.8603C16.0466 15.6741 16.0466 15.3722 15.8603 15.186L12.6743 12L15.8603 8.81397C16.0466 8.62777 16.0466 8.32586 15.8603 8.13966C15.6741 7.95345 15.3722 7.95345 15.186 8.13966L12 11.3257L8.81397 8.13966C8.62777 7.95345 8.32586 7.95345 8.13966 8.13966C7.95345 8.32586 7.95345 8.62777 8.13966 8.81397L11.3257 12Z" />
    </svg>
  );
}